import { DecimalPipe } from '@angular/common';
import { Component  } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';
import { ListadoOperacionesProspectosComponent } from './listado-operaciones-prospectos/listado-operaciones-prospectos.component';
@Component({
  selector: 'app-prospectos',
  templateUrl: './prospectos.component.html',
  styleUrls: ['./prospectos.component.scss'],
  providers:[ListadoOperacionesProspectosComponent,DecimalPipe]
})

export class ProspectosComponent   {
  Label_Prospectos=environment.LABEL_PROSPECTOS;
  Label_Prospecto=environment.LABEL_PROSPECTO;

  abrirNuevoProspecto : boolean = false;
  constructor(private loginService:LoginService, private router:Router,
    private excel:ListadoOperacionesProspectosComponent
    ) { }

 

  clickGuard(){
      this.loginService.clickGuard = true;
  }

  crearNuevoProspecto(){
    this.abrirNuevoProspecto = true;
  } 

  CerrarPopUpNuevoProspecto(){
    this.abrirNuevoProspecto = false;
  }

  Refresh(){
    this.loginService.clickGuard = true;
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.loginService.clickGuard = true;
        this.router.navigate([currentUrl]);
    });
  }
  ExportTOExcel(){
  this.excel.ExportTOExcel()
  }
}